"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var FacebookIcon = function FacebookIcon() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 50 50",
    "aria-labelledby": "facebook-title",
    role: "img"
  }, _react["default"].createElement("title", {
    id: "facebook-title"
  }, "Facebook Icon"), _react["default"].createElement("g", null, _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M12.38,11.44",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  }), _react["default"].createElement("path", {
    d: "M12.38,20.16",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  }), _react["default"].createElement("path", {
    d: "M17.33,31.54",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  }), _react["default"].createElement("path", {
    d: "M12,38.43",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  }), _react["default"].createElement("circle", {
    cx: "40.25",
    cy: "7.75",
    r: "1.25",
    fill: "#fff"
  }), _react["default"].createElement("path", {
    d: "M37.21,5.18a23,23,0,1,0,5.61,5.61",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  }), _react["default"].createElement("path", {
    d: "M29.15,24.78l.66-5.15h-5.1V16.34c0-1.49.41-2.51,2.55-2.51H30V9.22A36.33,36.33,0,0,0,26,9c-3.93,0-6.62,2.4-6.62,6.81v3.8H15v5.15H19.4V38h5.32V24.78Z",
    fill: "#fff"
  }))));
};

var _default = FacebookIcon;
exports["default"] = _default;